import { useEffect, useState } from "react";
import { fetchTripApprovalData, sendTripApprovalRequest } from "../Api/TripApproval";
import { Container, Table, Button } from "react-bootstrap";
import Dashboard from "../Components/Dashboard";
import { toast } from "react-toastify";
//import "./../Styling/TripApproval.css";

const TripApproval = () => {
  const [approvals, setApprovals] = useState([]);

  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchTripApprovalData();
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Trip Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (tripId) => {
    try {
      await sendTripApprovalRequest(tripId);
      toast.success(`🟢 Trip ${tripId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Trip Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Trip Approval</span>

          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Trip Id</th>
                      <th>Employee ID</th>
                      <th>Trip Name</th>
                      <th>Purpose of Travel</th>
                      <th>Department</th>
                      <th>Manager's Name</th>
                      <th>Trip Start Date</th>
                      <th>Trip End Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval.tripId}</td>
                        <td>{approval.employeeId}</td>
                        <td>{approval.tripName}</td>
                        <td>{approval.purposeofTravel}</td>
                        <td>{approval.department}</td>
                        <td>{approval.managersName}</td>
                        <td>{new Date(approval.tripStartDate).toLocaleDateString()}</td>
                        <td>{new Date(approval.tripEndDate).toLocaleDateString()}</td>
                        <td className={approval.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {approval.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                        <td>
                          {approval.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(approval.tripId)}
                              className="approve-btn"
                            >
                              Approve
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No trip approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default TripApproval;